export const tr = {
    'description-text':
        'Zorunlu sertifika, kayıt veya lisansa tabi olan ürünler ya da hizmetler için belgeler ibraz edilmelidir.',
    'one-banner-title-hint': 'Öneri, reklamın yayınlanması için belge ibraz edilmesi gerektiğinden gösterilmektedir',
    'send-lisence-letter': 'Belgeleri gönder',
    'several-banners-title-hint':
        'Öneri, bazı reklamların yayınlanması için belge ibraz edilmesi gerektiğinden gösterilmektedir',
    title: '"{theme}" konulu reklamlar için gerekli belgeleri gönderin'
};
